import { h } from 'vue';
export { ArrowUpIcon, ArrowDownIcon, CheckIcon} from 'lucide-vue-next'

const createIcon = (children) => {
    return {
        name: "Icon",
        functional: true,
        props: {
            className: String,
            class: String
        },
        setup(props, { attrs }) {
            return () =>
                h(
                    "svg",
                    {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        class: props.className || props.class,
                        ...attrs
                    },
                    children
                );
        }
    };
};

export const CalendarIcon = createIcon([
    h('rect', { x: "3", y: "4", width: "18", height: "18", rx: "2", ry: "2" }),
    h('line', { x1: "16", y1: "2", x2: "16", y2: "6" }),
    h('line', { x1: "8", y1: "2", x2: "8", y2: "6" }),
    h('line', { x1: "3", y1: "10", x2: "21", y2: "10" })
]);

export const CopyIcon = createIcon([
    h('rect', { x: "9", y: "9", width: "13", height: "13", rx: "2", ry: "2" }),
    h('path', { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
]);

export const TrashIcon = createIcon([
    h('path', { d: "M3 6h18" }),
    h('path', { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
    h('path', { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" })
]);

export const EditIcon = createIcon([
    h('path', { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
    h('path', { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
]);

export const ChevronDownIcon = createIcon([
    h('polyline', { points: "6 9 12 15 18 9" })
]);

export const ChevronUpIcon = createIcon([
    h('polyline', { points: "18 15 12 9 6 15" })
]);

export const ChevronLeftIcon = createIcon([
    h('polyline', { points: "15 18 9 12 15 6" })
]);

export const ChevronRightIcon = createIcon([
    h('polyline', { points: "9 18 15 12 9 6" })
]);

export const PlusIcon = createIcon([
    h('line', { x1: "12", y1: "5", x2: "12", y2: "19" }),
    h('line', { x1: "5", y1: "12", x2: "19", y2: "12" })
]);

export const ClipboardPasteIcon = createIcon([
    h('path', { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }),
    h('rect', { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1" })
]);

export const XIcon = createIcon([
    h('line', { x1: "18", y1: "6", x2: "6", y2: "18" }),
    h('line', { x1: "6", y1: "6", x2: "18", y2: "18" })
]);

export const SaveIcon = createIcon([
    h('path', { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
    h('polyline', { points: "17 21 17 13 7 13 7 21" }),
    h('polyline', { points: "7 3 7 8 15 8" })
]);

export const FileTextIcon = createIcon([
    h('path', { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
    h('polyline', { points: "14 2 14 8 20 8" }),
    h('line', { x1: "16", y1: "13", x2: "8", y2: "13" }),
    h('line', { x1: "16", y1: "17", x2: "8", y2: "17" }),
    h('polyline', { points: "10 9 9 9 8 9" })
]);

export const LayoutGridIcon = createIcon([
    h('rect', { x: "3", y: "3", width: "7", height: "7" }),
    h('rect', { x: "14", y: "3", width: "7", height: "7" }),
    h('rect', { x: "14", y: "14", width: "7", height: "7" }),
    h('rect', { x: "3", y: "14", width: "7", height: "7" })
]);

export const PieChartIcon = createIcon([
    h('path', { d: "M21.21 15.89A10 10 0 1 1 8 2.83" }),
    h('path', { d: "M22 12A10 10 0 0 0 12 2v10z" })
]);

export const KeyIcon = createIcon([
    h('path', { d: "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" })
]);

export const HeadphonesIcon = createIcon([
    h('path', { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
    h('path', { d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" })
]);

export const SearchIcon = createIcon([
    h('circle', { cx: "11", cy: "11", r: "8" }),
    h('line', { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })
]);

export const FilterIcon = createIcon([
    h('polygon', { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
]);

export const MoreHorizontalIcon = createIcon([
    h('circle', { cx: "12", cy: "12", r: "1" }),
    h('circle', { cx: "19", cy: "12", r: "1" }),
    h('circle', { cx: "5", cy: "12", r: "1" })
]);

export const ArrowUpDownIcon = createIcon([
    h('path', { d: "m7 15 5 5 5-5" }),
    h('path', { d: "m7 9 5-5 5 5" })
]);

export const LinkIcon = createIcon([
    h('path', { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
    h('path', { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
]);

export const BanIcon = createIcon([
    h('circle', { cx: "12", cy: "12", r: "10" }),
    h('line', { x1: "4.93", y1: "4.93", x2: "19.07", y2: "19.07" })
]);

export const DownloadIcon = createIcon([
    h('path', { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
    h('polyline', { points: "7 10 12 15 17 10" }),
    h('line', { x1: "12", y1: "15", x2: "12" }) // Simplified line
]);

export const MessageSquareIcon = createIcon([
    h('path', { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
]);

export const TelegramIcon = createIcon([
    h('path', { d: "M21.198 2.433a2.242 2.242 0 0 0-1.022.215l-8.609 3.33c-2.068.8-4.133 1.598-5.724 2.21a405.15 405.15 0 0 1-2.863 1.13c-1.192.561-1.66 1.137-1.545 1.769.112.624.673 1.18 1.838 1.622l2.31 1.011 5.372-3.38c.119-.075.291-.038.36.082.069.12.038.291-.082.36l-4.52 3.125-.138 2.45c.018.572.29.98.58 1.192.348.256.74.246 1.13.063l2.52-1.782 3.523 2.6c1.295.961 2.378.537 2.656-.99l1.96-10.58a2.25 2.25 0 0 0-.215-1.565 2.25 2.25 0 0 0-1.53-.962z" })
]);

export const ViberIcon = createIcon([
    h('path', { d: "M17.4 14.5c-.5-1.1-2.9-1.9-3.2-1.9-.3 0-.6.1-.8.4-.2.3-1 1.3-1.2 1.6-.2.3-.5.3-.8.2-1.4-.7-2.6-2-3.3-3.4-.1-.3-.1-.6.2-.8.2-.2.8-1.1.9-1.4.1-.3.1-.6-.1-1-.4-.8-1.5-3.6-2-4.9-.4-1-.8-.9-1.1-.9h-1c-.4 0-1 .2-1.5.8C2 4.6 2 7.2 4.1 9.4c2.5 2.5 5.9 3.5 8.9 3.5.4 0 .9 0 1.3-.1 2.2-.4 3-1.9 3.5-3 .1-.6-.2-1-.6-1.3z" }),
    h('path', { d: "M15.5 7.5c1.1 1.1 1.1 2.9 0 4" }),
    h('path', { d: "M18.5 4.5c2.8 2.8 2.8 7.2 0 10" })
]);

export const MailIcon = createIcon([
    h('rect', { width: "20", height: "16", x: "2", y: "4", rx: "2" }),
    h('path', { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" })
]);

export const PrinterIcon = createIcon([
    h('polyline', { points: "6 9 6 2 18 2 18 9" }),
    h('path', { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
    h('rect', { x: "6", y: "14", width: "12", height: "8" })
]);

export const CreditCardIcon = createIcon([
    h('rect', { width: "20", height: "14", x: "2", y: "5", rx: "2" }),
    h('line', { x1: "2", x2: "22", y1: "10", y2: "10" })
]);

export const RotateCcwIcon = createIcon([
    h('path', { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
    h('path', { d: "M3 3v5h5" })
]);

export const XCircleIcon = createIcon([
    h('circle', { cx: "12", cy: "12", r: "10" }),
    h('path', { d: "m15 9-6 6" }),
    h('path', { d: "m9 9 6 6" })
]);

export const InvoiceFilterLoaderIcon = createIcon([
    h('path', { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", class: "text-slate-300 animate-pulse" }),
    h('polyline', { points: "14 2 14 8 20 8", class: "text-slate-400" }),
    h('line', { x1: "16", y1: "13", x2: "8", y2: "13", class: "text-slate-300" }),
    h('line', { x1: "16", y1: "17", x2: "8", y2: "17", class: "text-slate-300" }),
    h('g', { style: "transform-origin: center; transform-box: fill-box", class: "animate-bounce" }, [
        h('polygon', {
            points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3",
            class: "fill-blue-500 stroke-white stroke-2",
            transform: "translate(4, 4) scale(0.6)"
        })
    ])
]);
